import { ITheme } from '../../app/shared/interfaces/ITheme';

export const lightTheme: ITheme = {
    colorGrey: '#e0e0e0'
};

export const darkTheme: ITheme = {
    colorGrey: '#e0e0e0'
};
